import { lang } from '../../assets/lang'

export const triggerHtml =

'<div id="trigger-trigger-keyword-group" class="trigger-onDemand-field form-group text-left mt-2">' + 
'<label for="trigger-trigger-keyword">' + lang.trigger_html_info_keywords + '</label>' +
'<input type="text" class="form-control" id="trigger-trigger-keyword" aria-describedby="trigger-trigger-keyword-help" placeholder="' + lang.trigger_html_placeholder_keywords + '">' +
'</div>'+

'<div class="form-group pb-3 mt-2 text-left">' +
  '<label class="pb-1">' + lang.trigger_html_matching_type + '</label>' +
  '<div class="row">' +
    '<div class="col-12">' +
      '<div class="selectgroup w-100">' +
        '<label class="selectgroup-item pb-2">' +
          '<input type="radio" name="trigger-matching-type" value="exact" class="selectgroup-input" checked="">' +
          '<span class="selectgroup-button">' + lang.trigger_html_exact_match + '</span>' +
        '</label>' +
        
        '<label class="selectgroup-item pb-2">' +
          '<input type="radio" name="trigger-matching-type" value="string" class="selectgroup-input">' +
          '<span class="selectgroup-button">' + lang.trigger_html_string_match + '</span>' +
        '</label>' +
      '</div>' +
    '</div>' +
  '</div>' +
'</div>'
